<div role="dialog"
     aria-modal="true"
     class="td-wb-filter-window__panel"
     aria-labelledby="td-wb-aria-filter-title">
  <div class="td-wb-filter-window__header">
    <h2 id="td-wb-aria-filter-title">
      <ng-content select=".td-wb-filter-window__header-title" />
    </h2>
    <button class="td-wb-filter-window__header-close-button"
            tdWbButton
            tdWbButtonType="icon"
            [attr.aria-label]="'tdWb.help.CLOSE' | tdWbTranslate"
            (click)="close()">
      <td-wb-icon iconId="close--small"
                  size="15" />
    </button>
  </div>
  <div class="td-wb-filter-window__container">
    <ng-content />
  </div>
</div>


